import { basicExtensions, useEditor } from '@modules/editor';
import { chatImagePasteExtension } from '@modules/editor/extensions/chatImagePaste';
import { emojiSearchExtension } from '@modules/editor/extensions/emojiSearch';
import { userMentionExtension } from '@modules/editor/extensions/userMention';
import { shallowEqual } from 'react-redux';
import { IWorkspaceUser } from 'src/@types/workspace-info';
import { useSelector } from 'src/redux/store';

type Props = {
  conversationId: string;
  mentionableParticipants?: IWorkspaceUser[];
  handleChatUploadFile?: (file: File) => void;
  placeholder?: string;
};

const extensions = [
  ...basicExtensions,
  userMentionExtension,
  emojiSearchExtension,
  chatImagePasteExtension,
  // spaceForAiExtension,
];

/**
 * @deprecated you should be using useConversationEditorConfig value provided via context and useConversationEditor to instanciate the editor with draft feature
 */
export const useConversationEditorExtensions = ({
  conversationId,
  mentionableParticipants = [],
  handleChatUploadFile,
  placeholder = 'Type a message. Use @ to quote a user',
}: Props) => {
  const workspaceUsers = useSelector(
    (state) => state.workspace.workspace.users,
    shallowEqual,
  );

  const { editor, currentValue, editorLoaded } = useEditor(
    {
      extensions,
      content: '',
      extensionConfig: {
        enterBehave: {
          createNewLine: false,
        },
        placeholder,
        userMention: {
          enabled: true,
          getUserById(id) {
            if (!workspaceUsers?.length) return null;
            const item = workspaceUsers?.find((user) => user._id === id);
            if (!item) return null;

            return {
              _id: item._id,
              picture: item.picture,
              name: item.name,
              status: item.status,
            };
          },
          async findUsers(search) {
            if (!mentionableParticipants?.length) return [];
            return mentionableParticipants?.filter((item) =>
              item.name
                .toLocaleLowerCase()
                .includes(search.toLocaleLowerCase()),
            );
          },
        },
        chatUploadFile: handleChatUploadFile,
      },
    },
    [],
  );

  return { editor, currentValue, editorLoaded };
};
